import {equals} from 'ramda';

import {SaveSaleVehicleFinancingBody} from '@dms/api/vehicle';

import {normalizeDecimalValue} from '../normalizeDecimalValue';
import {normalizeMoneyValue} from '../normalizeMoneyValue';

function normalizeFinancingBody(body: SaveSaleVehicleFinancingBody) {
  return {
    ...body,
    processingFeeOverride: normalizeMoneyValue(body.processingFeeOverride),
    vehicleTransferAmountOverride: normalizeMoneyValue(body.vehicleTransferAmountOverride),
    vehicleRegistrationAmountOverride: normalizeMoneyValue(body.vehicleRegistrationAmountOverride),
    vehicleDeliveryAmountOverride: normalizeMoneyValue(body.vehicleDeliveryAmountOverride),
    liabilityInsuranceMonthly: normalizeMoneyValue(body.liabilityInsuranceMonthly),
    liabilityInsuranceDeductible: normalizeMoneyValue(body.liabilityInsuranceDeductible),
    comprehensiveInsuranceMonthly: normalizeMoneyValue(body.comprehensiveInsuranceMonthly),
    comprehensiveInsuranceDeductible: normalizeMoneyValue(body.comprehensiveInsuranceDeductible),
    rateMatrix: {
      availableTerms: [...body.rateMatrix.availableTerms].sort((left, right) => left - right),
      cells: [...body.rateMatrix.cells]
        .map((cell) => ({
          ...cell,
          nominalRate: normalizeDecimalValue(cell.nominalRate) ?? cell.nominalRate,
          apr: normalizeDecimalValue(cell.apr) ?? cell.apr,
        }))
        .sort(
          (left, right) =>
            left.term - right.term ||
            (left.balloonPayment ?? -1) - (right.balloonPayment ?? -1) ||
            left.downPayment - right.downPayment
        ),
    },
  };
}

export function areFinancingBodiesEqual(
  baseline: SaveSaleVehicleFinancingBody,
  current: SaveSaleVehicleFinancingBody
) {
  return equals(normalizeFinancingBody(baseline), normalizeFinancingBody(current));
}
